/**
 * 小说选择器数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref } from 'vue';
import { getNovels } from './api';

export const novelSelectorWebSocket = () => {
    const connected = ref(true); // Axios 总是"连接"状态
    const novels = ref([]);
    const loading = ref(false);
    const error = ref(null);

    // 请求小说列表
    const fetchNovels = async () => {
        loading.value = true;
        error.value = null;

        try {
            const result = await getNovels();
            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (result.code === 0) {
                novels.value = result.data;
                console.log('获取小说列表成功');
            } else {
                error.value = result.msg || '获取小说列表失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            error.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    return {
        connected,
        novels,
        loading,
        error,
        fetchNovels,
    };
};
